/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Location, LocationContext } from '@reach/router';
import Page from '@components/layout/Page';
import Container from '@components/layout/Container';
import { ArticleGrid } from '@components/article/ArticleGrid';
import { NewsDataProps } from '@graphql/queries/NewsQuery';
import { PageContext } from '@content/types/pageContext';
import MetaPage from '@components/common/MetaPage';
import JsonLd from '@components/common/JsonLd';
import useOrganizationQuery from '@graphql/queries/OrganizationQuery';
import { LocationDependent } from '@content/types/general';
import { absoluteUrl, absoluteImageUrl, buildArticleSchema, getLogoUrl } from '@utils/structuredData';

export interface NewsProps extends NewsDataProps, LocationDependent {
  pageContext: PageContext;
  urls: Array<string>;
}

export default (props: NewsProps) => {
  const organization = useOrganizationQuery();
  const article =
    props.allNews[props.pageContext.langcode].find(
      article => article.slug === props.pageContext.slug
    ) || null;

  return (
    <Page>
      {article && <MetaPage title={article.seo.title} description={article.seo.description} image={article.seo.image} />}
      {article && (
        <Location>
          {({ location }: LocationContext) => (
            <JsonLd
              schema={buildArticleSchema({
                headline: article.title,
                url: absoluteUrl(location.pathname),
                orgName: organization.name,
                logoUrl: getLogoUrl(),
                datePublished: article.date,
                dateModified: article.dateModified,
                articleSection: article.categories[0],
                imageUrl: article.seo.image ? absoluteImageUrl(article.seo.image) : undefined,
                description: article.seo.description,
              })}
            />
          )}
        </Location>
      )}
      <Container>
        <ArticleGrid
          article={article}
          href={props.location.href}
          allArticles={props.allNews[props.pageContext.langcode]}
          settings={props.newsSettings[props.pageContext.langcode]}
          langcode={props.pageContext.langcode}
          urls={props.urls}
        />
      </Container>
    </Page>
  );
};
